import React from "react";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./lib/auth";
import Login from "./pages/Login";
import DashboardLayout from "./pages/DashboardLayout";
import LawsuitRadar from "./pages/LawsuitRadar";
import GeoBlitz from "./pages/GeoBlitz";
import SiteAuditor from "./pages/SiteAuditor";
import ScriptDeployment from "./pages/ScriptDeployment";
import ImageManager from "./pages/ImageManager";
import BrandSettings from "./pages/BrandSettings";
import TeamPage from "./pages/TeamPage";
import AccountSecurity from "./pages/AccountSecurity";
import CompetitorHunt from "./pages/CompetitorHunt";
import InboundScans from "./pages/InboundScans";
import InboundLeads from "./pages/InboundLeads";
import SchedulePage from "./pages/SchedulePage";
import CompliancePage from "./pages/CompliancePage";
import CheckoutSuccessPage from "./pages/CheckoutSuccessPage";
import MarketingLanding from "./pages/MarketingLanding";
import { Loader2 } from "lucide-react";

function ProtectedShell() {
  const { token, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-white">
        <Loader2 className="w-6 h-6 animate-spin text-zinc-700" />
      </div>
    );
  }
  if (!token) return <Navigate to="/login" replace />;
  return <Outlet />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MarketingLanding />} />
          <Route path="/login" element={<Login />} />
          <Route path="/schedule" element={<SchedulePage />} />
          <Route path="/compliance" element={<CompliancePage />} />
          <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
          <Route element={<ProtectedShell />}>
            <Route path="/operator" element={<DashboardLayout />}>
              <Route index element={<LawsuitRadar />} />
              <Route path="geo-blitz" element={<GeoBlitz />} />
              <Route path="auditor" element={<SiteAuditor />} />
              <Route path="deployments" element={<ScriptDeployment />} />
              <Route path="images" element={<ImageManager />} />
              <Route path="competitor-hunt" element={<CompetitorHunt />} />
              <Route path="inbound" element={<InboundScans />} />
              <Route path="leads" element={<InboundLeads />} />
              <Route path="brand" element={<BrandSettings />} />
              <Route path="team" element={<TeamPage />} />
              <Route path="account" element={<AccountSecurity />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}
